import { createStyles } from '@mantine/core';

import { Text } from '~/domains/design-system/Text';

const useStyles = createStyles((theme) => ({
  alternate: {
    position: 'absolute',
    top: 0,
    left: '50%',
    transform: 'translate(-50%, 0)',
    background: theme.white,
    zIndex: 3,
    minWidth: '50px',
    textAlign: 'center',
    height: 20,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    filter: 'drop-shadow(0px 0px 8px rgba(0, 0, 0, 0.1))',
    clipPath: 'inset(2px -20px -20px -20px)',

    '& span': {
      color: theme.colors.gray[6],
      zIndex: 4,
    },
  },

  triangle1: {
    position: 'absolute',
    left: -20,
    width: 0,
    height: 0,
    borderLeft: '20px solid transparent',
    borderRight: '20px solid transparent',

    borderTop: `20px solid ${theme.white}`,
  },
  triangle2: {
    position: 'absolute',
    right: -20,
    width: 0,
    height: 0,
    borderLeft: '20px solid transparent',
    borderRight: '20px solid transparent',

    borderTop: `20px solid ${theme.white}`,
  },
}));

function PlayerCardAlternate() {
  const { classes } = useStyles();

  return (
    <div className={classes.alternate}>
      <div className={classes.triangle1} />
      <Text variant="headline-x-small">ALT</Text>
      <div className={classes.triangle2} />
    </div>
  );
}

export default PlayerCardAlternate;
